import React from 'react';
import '../UnauthentifiedPages.scss';
import { Button, Container, Typography, Input, Spacing, Separator } from '@design-system';
import { useForgotPasswordPageVM } from './useForgotPasswordPageVM';
import Logo from '@assets/images/logo/logo-cosem.svg?react';
import { Formik } from 'formik';
import { ForgotPasswordRequest } from '@services/core/auth/auth.types';
import { useNavigate } from 'react-router-dom';

export const ForgotPasswordPage: React.FC = () => {
    const { handleSubmit, isLoading, isEmailSent } = useForgotPasswordPageVM();
    const navigate = useNavigate();

    const renderBackToLoginButton = () => (
        <Typography intrinsic="p" variant="p2" color="grey1" className="back-to-login" onClick={() => navigate('/login')}>
            Retour à la page de connexion
        </Typography>
    );

    const renderHeader = () => (
        <>
            <Logo />
            <Spacing size="x-large" />
            <Separator fullWidth />
            <Spacing size="large" />
        </>
    );

    return (
        <Container className="unauthentified-page">
            {renderHeader()}
            {isEmailSent ? (
                <>
                    <Typography intrinsic="p" className="welcome-back">
                        E-mail envoyé
                    </Typography>
                    <Spacing size="large" />
                    <Typography intrinsic="p">
                        Vous venez de recevoir un e-mail avec les instructions pour réinitialiser votre mot de passe.
                    </Typography>
                    <Spacing size="x-large" />
                    {renderBackToLoginButton()}
                </>
            ) : (
                <>
                    <Typography intrinsic="p" className="welcome-back">
                        Mot de passe oublié
                    </Typography>
                    <Spacing size="x-large" />
                    <Typography intrinsic="h1">Réinitialiser mon mot de passe</Typography>
                    <Spacing size="large" />
                    <Formik
                        initialValues={{ email: '' }}
                        onSubmit={async (values: ForgotPasswordRequest) => {
                            await handleSubmit(values);
                        }}
                    >
                        {({ values, handleChange, handleSubmit }) => (
                            <form onSubmit={handleSubmit}>
                                <Input
                                    label="Adresse e-mail"
                                    placeholder="Adresse e-mail"
                                    name="email"
                                    value={values.email}
                                    onChange={handleChange}
                                />
                                <Spacing size="x-small" />
                                <Spacing />
                                <Button variant="primary" disabled={isLoading}>
                                    <Typography intrinsic="p">Réinitialiser mon mot de passe</Typography>
                                </Button>
                            </form>
                        )}
                    </Formik>
                    <Spacing size="x-large" />
                    {renderBackToLoginButton()}
                </>
            )}
        </Container>
    );
};
